import { plainToClassFromExist, classToPlain, ClassTransformOptions } from 'class-transformer';
import { isObject } from 'lodash';

export abstract class SnModel {
  public fromJSON(data: any): void {
    if (data && isObject(data)) {
      plainToClassFromExist(this, data, { excludeExtraneousValues: true });
    }
  }

  public toJSON(options?: ClassTransformOptions): Object {
    return classToPlain(this, {
      excludeExtraneousValues: true,
      ...options,
    });
  }

  public clone(): any {
    const cloneObj = Object.create(this);

    Object.keys(this).forEach((attribut) => {
      cloneObj[attribut] = this._cloneDeep(this[attribut]);
    });

    return cloneObj;
  }

  private _cloneDeep(value: any): any {
    if (Array.isArray(value)) {
      return value.map((item) => this._cloneDeep(item));
    }

    if (value !== null && typeof value === 'object') {
      if (value instanceof SnModel) {
        return value.clone();
      }

      if (value instanceof Date) {
        return new Date(value);
      }

      const nextValue = Object.create(value);

      Object.keys(value).forEach((attribute) => {
        nextValue[attribute] = this._cloneDeep(value[attribute]);
      });

      return nextValue;
    }

    return value;
  }
}
